import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { privateApi } from "../../../api/api";
import { DeleteBillingConnectionResponseSchema } from "../response/BillingConnectionResponse";
import { BILLING_CONNECTIONS_QUERY_KEY } from "./useIndexBillingConnections";

interface DeleteBillingConnectionVariables {
    id: string;
}

/** DELETE /v4/billing-connections/{id} */
export const useDeleteBillingConnection = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id }: DeleteBillingConnectionVariables) => {
            if (!id) {
                throw new Error("Connection ID is required for deletion.");
            }
            const response = await privateApi.delete(`/v4/billing-connections/${id}`);
            return response.data;
        },
        onSuccess: async (responseData) => {
            const validationResult = DeleteBillingConnectionResponseSchema.safeParse(responseData);
            if (!validationResult.success) {
                console.error("API Response Validation Failed on Success:", validationResult.error.errors);
            }
            await queryClient.invalidateQueries({ queryKey: [BILLING_CONNECTIONS_QUERY_KEY] });
        },
        onError: (error) => {
            console.error("Failed to delete billing connection:", isAxiosError(error) ? error.response?.status : error.message);
        },
    });
};
